(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["mcpGrowthTrafficTrainTripRecommend"] = factory();
	else
		root["mcpGrowthTrafficTrainTripRecommend"] = factory();
})(window, function() {
return 